import axios from "axios";
import { Action } from "helper/alert";
import { reactLocalStorage } from "reactjs-localstorage";
const Axios = axios

const hostname = window && window.location && window.location.hostname
const mainURL = 'https://api-configroup.wuebuild.com/dashboard'
const stagingURL = 'https://staging-api-configroup.wuebuild.com/dashboard'
const localURL = 'http://localhost:9800/dashboard'

let url = hostname ? hostname.includes('staging-configroup.wuebuild.com') ? stagingURL :
  hostname.includes('configroup.wuebuild.com') ? mainURL : 
  hostname && hostname.includes('localhost') ? localURL : mainURL : mainURL

console.log('hostname', hostname, url)

export const getToken = () => {
  try {
    let getUserInfo = reactLocalStorage.get('user_info')
    let userInfo = getUserInfo ? JSON.parse(getUserInfo) : null
    return userInfo ? userInfo.token : ''
  } catch (e) {
    // deleteUserInfo()
    reactLocalStorage.remove('user_info')
    return ''
  }
}

export const client = Axios.create({
  baseURL: url,
  headers: {
    'Content-Type': 'application/json',
    'x-access-token': getToken()
  },
  timeout: 10000,
});

export const errorValidation = (e) => {
  try {
    if (e.response.status === 405) { 
      reactLocalStorage.clear()
      Action("", "You've been logged out. Please login again.", () => {
        window.location.href = "/"
      })
    }
    if (e.response.status === 403) { 
      // deleteUserInfo()
    }
    console.log('here error', e.response)
    return { error: e.response.data.message || "Failed to fetch data" };
  } catch (error) {
    // toast('There is problem with server connection', {
    //   toastId: "error-api",
    //   type: "error"
    // });
    // Confirm("", "There is problem with server connection")
    return { error: "Failed to fetch data"}
  }
}